import { Grid, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import Fab from '@material-ui/core/Fab';

const ModuleNumber = ({ classes, number }) => (
  <Grid container direction={'column'}>
    <Grid item xs={12}>
      <Fab size={"medium"} color={'secondary'} disableRipple disableTouchRipple>
        <Typography variant={'h6'}>{number}</Typography>
      </Fab>
    </Grid>
  </Grid>
);

const styles = theme => ({});

export default withStyles(styles)(ModuleNumber);
